const wishlist = {
    wishlistWrapper:            '.wishlist__wrapper',
    wishlistItemClass:          '.wishlist__item',
    wishlistEmptyClass:         '.wishlist__empty__label',

    productPageWrapper:         '.product__wrapper',
    productListingWrapper:      '.product-item',

    productWishlistToggle:      '.product__wishlist__toggle',
    addToWishlistClass:         'product__wishlist__add',
    removeFromWishlistClass:    'product__wishlist__remove',

    counterWrapper:             '#WishlistButton',
    counterClass:               '.counter__label',

    addToWishlistTitle:         'Aggiungi alla lista dei preferiti',
    removeFromWishlistTitle:    'Rimuovi dalla lista dei preferiti',

    productPath:                '/products/',
    productPathSuffix:          '?view=wishlist',

    wishlistItems: [],
    destroyedDOM: false,

    // enable wishlist
    enableWishlist: true,

    /**
     * wishlist initialize
     */
    init: function () {
        if (this.enableWishlist) {
            // bind function to constructor
            this.addItemEvent       = this.addItemEvent.bind(this);
            this.removeItemEvent    = this.removeItemEvent.bind(this);
            this.updateRender       = this.updateRender.bind(this);
            this.updateData         = this.updateData.bind(this);

            this.bindAll();
            this.getWishlist(this.updateData);
            this.selectActiveWishlistItems();
        }
    },

    /**
     * Bind click on add to wishlist
     */
    bindAll: function () {
        const self = this;

        // product page
        $(this.productPageWrapper).on('click', this.productWishlistToggle, function (event) {
            if (typeof event !== 'undefined') {
                event.preventDefault();
                event.stopPropagation();
                // get product Name for message
                const productName = $(this).data('title');
                if ($(this).hasClass(self.addToWishlistClass)) {
                    self.addItemEvent(event.currentTarget);
                    self.swalMessages.addItem(productName);
                } else if ($(this).hasClass(self.removeFromWishlistClass)) {
                    self.removeItemEvent(event.currentTarget);
                    self.swalMessages.removeItem(productName);
                }
            }
        });

        // product listing
        $(this.productListingWrapper).on('click', this.productWishlistToggle, function (event) {
            if (typeof event !== 'undefined') {
                event.preventDefault();
                event.stopPropagation();
                // get product Name for message
                const productName = $(this).data('title');
                if ($(this).hasClass(self.addToWishlistClass)) {
                    self.addItemEvent(event.currentTarget);
                    self.swalMessages.addItem(productName);
                } else if ($(this).hasClass(self.removeFromWishlistClass)) {
                    self.removeItemEvent(event.currentTarget);
                    self.swalMessages.removeItem(productName);
                }
            }
        });

        // wishlist page
        $(this.wishlistWrapper).on('click', this.productWishlistToggle, function (event) {
            if (typeof event !== 'undefined') {
                event.preventDefault();
                event.stopPropagation();
                // get product Name for message
                const productName = $(this).data('title');
                if ($(this).hasClass(self.addToWishlistClass)) {
                    self.addItemEvent(event.currentTarget);
                    self.swalMessages.addItem(productName);
                } else if ($(this).hasClass(self.removeFromWishlistClass)) {
                    self.swalMessages.precessing();
                    self.removeItemEvent(event.currentTarget);
                }
            }
        });
    },

    /**
     * all SWAL2 messages
     */
    swalMessages: {
        /**
         * Add message on product add to wishlist
         *
         * @param {string} productName
         */
        addItem: function (productName) {
            if (typeof Swal === 'function') {
                Swal.fire({
                    position: 'top-end',
                    type: 'success',
                    customClass: {
                        icon: 'swal2-add',
                        cancelButton: 'custom-swal-toast-btn-close anim',
                        container: 'custom-swal-toast-container',
                        content: 'custom-swal-toast-content'
                    },
                    html: '<div style="padding: 0 10px">Il prodotto ' + productName + 'è stato aggiunto alla lista dei preferiti.</div>',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close-thin" viewBox="0 0 27 27"><g stroke="#979797" fill="none"   fill-rule="evenodd" stroke-linecap="square"><path d="M.5.5l26 26M26.5.5l-26 26"></path></g></svg>',
                    toast: true,
                    timer: 5000
                });
            }
        },

        /**
         * Add message on product remove from wishlist
         *
         * @param {string} productName
         */
        removeItem: function (productName) {
            if (typeof Swal === 'function') {
                Swal.fire({
                    position: 'top-end',
                    type: 'error',
                    customClass: {
                        icon: 'swal2-remove',
                        cancelButton: 'custom-swal-toast-btn-close anim',
                        container: 'custom-swal-toast-container',
                        content: 'custom-swal-toast-content'
                    },
                    iconHtml: '-',
                    html: '<div style="padding: 0 10px">Il prodotto ' + productName + 'è stato rimosso dalla lista dei preferiti.</div>',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close-thin" viewBox="0 0 27 27"><g stroke="#979797" fill="none"   fill-rule="evenodd" stroke-linecap="square"><path d="M.5.5l26 26M26.5.5l-26 26"></path></g></svg>',
                    toast: true,
                    timer: 5000
                });
            }
        },

        /**
         * Add message while processing the wishlist
         *
         * Used only on wishlist page
         */
        precessing: function () {
            if (typeof Swal === 'function') {
                Swal.fire({
                    type: 'info',
                    html: 'Stiamo elaborando la richiesta<div class="loader"><div class="loader-indeterminate"></div></div>',
                    showConfirmButton: false
                });
            }
        },

        /**
         * Add message when wishlist has finished processing
         *
         * Used only on wishlist page
         */
        updated: function () {
            if (typeof Swal === 'function') {
                if (Swal.isVisible()) {
                    Swal.fire({
                        type: 'success',
                        html: 'La lista dei preferiti è stata aggiornata',
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            }
        }
    },

    /**
     * all API functions
     */
    API: {
        nameInStorage: 'wishlist',
        // api settings
        remoteApiUrl: 'https://uni-ecomm-shopify.azurewebsites.net/api/',
        remoteApiPath: 'wishlist',
        remoteApiAuth: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjUxMTdjMTIyZjMxZjUzMWE0MGVjMmJlN2E3YjliZTA5NWRlZDcwYzExNDljOTlkODg0NzM5MThkNzQzMTYyOWJmM2VmMzY1ZjQ5MDJjMmNlIn0.eyJhdWQiOiIxIiwianRpIjoiNTExN2MxMjJmMzFmNTMxYTQwZWMyYmU3YTdiOWJlMDk1ZGVkNzBjMTE0OWM5OWQ4ODQ3MzkxOGQ3NDMxNjI5YmYzZWYzNjVmNDkwMmMyY2UiLCJpYXQiOjE3NDM1MTk0OTYsIm5iZiI6MTc0MzUxOTQ5NiwiZXhwIjoxNzc1MDU1NDk2LCJzdWIiOiIyIiwic2NvcGVzIjpbXX0.iHrkMKkBzsonoqg-ou-1mksV6Jl-DwnbrFJo6NPU2mRRk7O4567XhzUjIiPmo-p4kEasvuB-C9OP7VhtsW1GpozULDILDjZN4-JP__XoMoTm7WxmZEgPq8rSsIuT01Giz3gnZ3BMJ5MqaBf3ILlabkINTIQ6vVYA5v5X9VQ4bpkfLFYVajeJAL_4sWWgoW5cxbu39-cVsvNm9rwOJ7QPAiqDeZpojqi8u0LqnJWJmhhOIQOtU3gtyIIOVWaU3A_Fb29UvBsAU8xOwT_mvALa502TrZuaaRXrWolz03MAAjGEL1-ca0EcH5t_4-ATDAp6Aqaa_XdV4RRHZVbrAzlmknViEw6iiv6tqji8F5UB3W8u3czv8kU-zT8RCTHJDSkYeEU3fRe4Mk6SksoDlZB0LOYiO4zCPeWbbnrMTyzOhmg10jnmcNTgoOBGFlBCG6hQB8T_mc6-BsvOeBIGr-veS6R-EvUaAbo9Ey-haSjI22rq9JePqr8bfECrg6Ab0YZw57WI8yLlB-MKWsPSWyRNls2jblc9GEYxbJVV80MIHJ6I_Het3oRkUIK9HnKa7NaFTVGq3pdmgmDWRMcEoF6Gb4nYNfJXPNx6AyjQks6tmL9xVnOPr1DpQ2hkYSH_7k4_RMIWnjWjEA73B-j8N3qq4G2VEsOQqy9jR1xn19iW3GQ',
        token: 'tempToken',

        // variable were wishlist items is store instead of using localstorage everytime
        remoteEnable: true,

        /**
         * read data from localstorage
         *
         * @return JSON || false
         */
        readData: function () {
            const items = localStorage.getItem(this.nameInStorage);
            if (items === "") {
                return false;
            }

            const handleData = JSON.parse(items);

            for (i in handleData) {
                if (handleData[i] === null) {
                    handleData.splice(i, 1);
                }
            }

            return handleData;
        },

        /**
         * save data to localStorage and align api if needed
         *
         * @param {string || integer} customerId
         * @param {array} wishlist
         * @param {boolean} remote
         *
         * @return JSON
         */
        saveData: function (customerId, wishlist, remote) {
            if (this.remoteEnable && customerId && remote) {
                this.saveRemove(customerId, wishlist);
            }
            localStorage.setItem(this.nameInStorage, JSON.stringify(wishlist));
            return wishlist;
        },

        dataMerge: function(data1, data2) {
            function arrayUnique(array) {
                var a = array.concat();
                for(var i=0; i<a.length; ++i) {
                    for(var j=i+1; j<a.length; ++j) {
                        if(a[i] === a[j])
                            a.splice(j--, 1);
                    }
                }

                return a;
            }
            data1 = data1.concat(data2);
            data1 = arrayUnique(data1);
            return data1;
        },

        /**
         * read data from api and save into localStorage
         *
         * @param {string || integer} customerId
         * @param {function} callback
         */
        readRemote: function (customerId, callback, localData) {
            const self = this;
            // async update remote
            $.ajax({
                dataType: "json",
                url: this.remoteApiUrl + this.remoteApiPath,
                type: "POST",
                headers: {
                    "Authorization" : this.remoteApiAuth
                },
                data: {
                    type: 'GET',
                    token: this.token,
                    id: customerId,
                    storecode: 'it'
                },
                success: function (result) {
                    let dataToSave = result.data;

                    // fallback in case we receive a null value
                    if(dataToSave === null) dataToSave = [];

                    if (localData) {
                        dataToSave = self.dataMerge(dataToSave, localData);
                    }
                    self.saveData(customerId, dataToSave, false);
                    callback();
                }
            });
        },

        /**
         * push data to api
         *
         * @param {string || integer} customerId
         * @param {array} wishlist
         */
        saveRemove: function (customerId, wishlist) {
            if (wishlist.length === 0) {
                wishlist.push(null);
            }

            // async update remote
            $.ajax({
                dataType: "json",
                url: this.remoteApiUrl + this.remoteApiPath,
                type: "POST",
                headers: {
                    "Authorization" : this.remoteApiAuth
                },
                data: {
                    type: 'SET',
                    token: this.token,
                    id: customerId,
                    data: wishlist,
                    storecode: 'it'
                }
            });
        }

    },

    /**
     * check if product is in wishlist and assign class for both status:
     *
     * -removeButtonClass "removeFromWishlistClass"
     * -addButtonClass "addToWishlistClass"
     */
    selectActiveWishlistItems: function () {
        const self = this;
        if ($(document).find(this.productWishlistToggle).length > 0) {
            $(this.productWishlistToggle).addClass(self.addToWishlistClass);
            $(this.productWishlistToggle).attr('title', self.addToWishlistTitle);

            if (this.wishlistItems) {
                for (var index = 0; index < this.wishlistItems.length; index++) {
                    var val = this.wishlistItems[index],
                        $element = $(document).find("[data-product-handle='" + val + "'");
                    // design changes
                    $element.removeClass(self.addToWishlistClass);
                    $element.addClass(self.removeFromWishlistClass);
                    $element.attr('title', self.removeFromWishlistTitle);
                }
            }
        }
    },

    /**
     * get current customer
     *
     * @return customerId || false
     */
    getCustomer: function () {
        // window.customerLogged is always declared but can be true or false based on customer status
        if (window.customerLogged) {
            // customerId property can be undeclared
            if (window.hasOwnProperty('customerId')) {
                return window.customerId;
            }
        }
        return false;
    },

    /**
     * call api and/or check with localstorage
     *
     * @param {function} callback
     */
    getWishlist: function (callback) {
        const customerId = this.getCustomer();
        if (customerId && this.API.remoteEnable) {
            return this.API.readRemote(customerId, callback, this.API.readData());
        }
        this.wishlistItems = this.API.readData();
        return callback();
    },

    /**
     * call for shopify liquid template and render it
     *
     * @param {jQuery element} $wishlistWrapper
     */
    getTemplate: function ($wishlistWrapper) {
        var self = this;

        setTimeout(function() {
            let $wishlistTemplate = "";

            for (var index = 0; index < self.wishlistItems.length; index++) {
                var productHandle = self.wishlistItems[index];
                $wishlistTemplate += self.getProductTemplate(productHandle);
            }

            if (self.wishlistItems.length > 0 && $wishlistTemplate !== '') {
                $wishlistWrapper.find(self.wishlistEmptyClass).hide();
            } else {
                $wishlistWrapper.find(self.wishlistEmptyClass).show();
            }
            // remove old items
            $wishlistWrapper.find(self.wishlistItemClass).remove();
            // update item list
            $wishlistWrapper.append($wishlistTemplate);
            self.selectActiveWishlistItems();
            // new message for process end
            self.swalMessages.updated();
        }, 250);
    },

    /**
     * get tempalte of each product using shopify views
     *
     * @param {string} productHandle
     */
    getProductTemplate: function (productHandle) {
        let returnData = '';
        $.ajax({
            url: this.getProductTemplatePath(productHandle),
            type : "get",
            async: false,
            success: function (data) {
                returnData = data;
            },
            error: function() {
                returnData = '';
            }
        });
        return returnData;
    },

    /**
     * get product template path based on shopify views
     *
     * @param {string} productHandle
     */
    getProductTemplatePath: function (productHandle) {
        return this.productPath + productHandle + this.productPathSuffix;
    },

    /**
     * handle add product to wishlist
     *
     * Element with a data-product-handle for identify the product
     * @param {DOMElement || event.currentTarget}  target
     */
    addItemEvent: function (target) {
        // handle current product
        let $element = $(target),
            productHandle = $(target).data('product-handle');
        // design changes
        $element.removeClass(this.addToWishlistClass);
        $element.addClass(this.removeFromWishlistClass);
        $element.attr('title', this.removeFromWishlistTitle);
        // init memory process
        this.addItem(productHandle);
    },

    /**
     * handle add product to wishlist passing the product-handle
     *
     * @param {string || integer} itemHandle
     */
    addItem: function (itemHandle) {
        // read wishlist
        let apiResponse = this.API.readData(),
            data = apiResponse ? apiResponse : [];
        // add element
        data.push(itemHandle);
        this.manageData(data);
    },

    /**
     * handle remove product to wishlist
     *
     * Element with a data-product-handle for identify the product
     * @param {DOMElement || event.currentTarget}  target
     */
    removeItemEvent: function (target) {
        // handle current product
        let $element = $(target),
            productHandle = $(target).data('product-handle');
        // design changes
        $element.removeClass(this.removeFromWishlistClass);
        $element.addClass(this.addToWishlistClass);
        $element.attr('title', this.addToWishlistTitle);
        // init memory process
        this.removeItem(productHandle);
    },

    /**
     * handle remove product to wishlist passing the product-handle
     *
     * @param {string || integer} itemHandle
     */
    removeItem: function (itemHandle) {
        // read wishlist
        let data    = this.API.readData(),
            index   = data.indexOf(itemHandle);
        if (index !== -1) {
            data.splice(index, 1);
        }
        this.manageData(data);
    },

    /**
     * manage data for both adding and removing items from wishlist
     *
     * @param {object} data
     */
    manageData: function (data) {
        // save wishlist local and api
        this.API.saveData(this.getCustomer(), data, true);
        // update component
        this.updateData();
    },

    /**
     * update data of component and re-render
     */
    updateData: function () {
        this.wishlistItems = this.API.readData();
        this.updateRender();
    },

    /**
     * re-render wishlist and wishlist counter
     */
    updateRender: function () {
        if (this.wishlistItems) {
            this.engine();
            this.engineCounter();
        }
    },

    /**
     * generate template where it's needed
     */
    engine: function () {
        if ($(this.wishlistWrapper).length > 0) {
            const $wishlistWrapper = $(this.wishlistWrapper);
            if (this.destroyedDOM) {
                $wishlistWrapper.append(this.destroyedDOM);
                this.destroyedDOM = false;
                return true;
            }
            this.getTemplate($wishlistWrapper);
        }
    },

    /**
     * engine for print the counter of item in wishlist
     *
     * DOM Required:
     *
     * parent based on this.counterWrapper
     *  child based on this.counterClass
     */
    engineCounter: function () {
        if ($(this.counterWrapper).length > 0) {
            let $counterWrapper = $(this.counterWrapper);
            if (this.wishlistItems.length > 0) {
                $counterWrapper.addClass('active');
            } else {
                $counterWrapper.removeClass('active');
            }

            if ($counterWrapper.find(this.counterClass).length > 0) {
                const $counterWrapper = $(this.counterWrapper),
                $counterLabel   = $counterWrapper.find(this.counterClass);
                $counterLabel.text(this.wishlistItems.length);
            }
        }
    }
}